import { render, staticRenderFns } from "./DocMasterGridView.vue?vue&type=template&id=61b4f6f2&scoped=true&"
import script from "./DocMasterGridView.vue?vue&type=script&lang=js&"
export * from "./DocMasterGridView.vue?vue&type=script&lang=js&"
import style0 from "./DocMasterGridView.vue?vue&type=style&index=0&id=61b4f6f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b4f6f2",
  null
  
)

export default component.exports